jQuery($ => {
	const $body = $('body');
	const $openSearch = $('.js-btn-open-search');
	const $closeSearch = $('.js-btn-close-search');
	const $navChildren = $('.js-nav-toggle-children');
	const $header = $('.header');

	// Toggle nav children
	$navChildren.click(function() {
		$(this)
			.parent()
			.toggleClass('open');
	});

	// Open search
	$openSearch.click(function() {
		$body.addClass('search-open');
	});

	// Close search and return back to the search button
	$closeSearch.click(function() {
		$body.removeClass('search-open');
		$openSearch.focus();
	});
	//On Esc key, close the search and return back to the search button
	$(document).keyup(function(e) {
		if ($body.hasClass('search-open') && e.key === 'Escape') {
			// escape key maps to keycode `27`
			$body.removeClass('search-open');
			$openSearch.focus();
		}
	});

	// Shrink header on on scroll down
	document.addEventListener(
		'scroll',
		_.throttle(() => {
			hasScrolled();
		}, 10)
	);

	function hasScrolled() {
		let scrollTop = $(window).scrollTop();

		if (window.pageYOffset >= 250) {
			$header.addClass('scrolled');
		} else {
			$header.removeClass('scrolled');
		}

		lastScrollTop = scrollTop;
	}
});
